import { defineMessages } from 'react-intl';

export default defineMessages({
  closeTooltip: {
    id: 'Tooltip.closeTooltip',
    description: 'Message for the aria label in the close button',
    defaultMessage: 'Close',
  },
});
